import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Chip,
  Divider,
  useTheme,
  Avatar,
  Checkbox,
} from "@mui/material";
import AgGridTable from "../../components/table/AgGridTable";
import useFrameworks from "../../shared/hooks/useFrameworks";
import { ColDef } from "ag-grid-community";
import sparkLogo from "../../assets/Spark-text.svg";
//import csiLogo from '../../assets/cis.png';
import csiLogo from "../../assets/cis_light.svg";
import ubuntu_dark from "../../assets/ubuntu_dark.svg";
import Windows_light from "../../assets/baseVersion/Windows_light.svg";
import Windows_dark from "../../assets/baseVersion/Windows_dark.svg";
import ubuntu_White from "../../assets/ubuntu_white.svg";
import debian from "../../assets/debian.svg";
import debian_dark from "../../assets/debian_dark.svg";
import huawei_light from "../../assets/huawei-ar21 1.svg";
import mikrotik from "../../assets/mikrotik.svg";
import mikrotik_dark from "../../assets/mikrotik_dark.svg";
import huawei_dark from "../../assets/huawei-dark.svg";
import edgecore_logo from "../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../assets/apple.svg";
import apple_dark from "../../assets/apple_dark.svg";
import dell_logo from "../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../assets/syrotech_light.svg";
import syrotech_dark from "../../assets/syrotech_dark.svg";
import nistLogo from "../../assets/nist.svg";
import nist_dark from "../../assets/nist_dark.svg";
import spark_dark from "../../assets/spark_dark.svg";
import cis_dark from "../../assets/cis_dark.svg";
import axiosInstance from "../../axios/axios";
import { END_POINTS } from "../../shared";
import Exclamation from "../../assets/Exclamation.png";
import ciscoLogo from "../../assets/cisco.svg";
import CiscoLogo_dark from "../../assets/cisco_dark.svg";
import aristaLogo from "../../assets/arista.svg";
import AristaLogo_dark from "../../assets/arista_dark.svg";
import juniperLogo from "../../assets/juniper.svg";
import JuniperLogo_dark from "../../assets/juniper_dark.svg";
import palaoto_dark from "../../assets/palaoto_dark.svg";
import paloaltoLogo from "../../assets/paloalto.svg";
import riskHistoryNA from "../../assets/risk_history_NA.svg";
import riskHistoryTick from "../../assets/risk_history_tick.svg";
import riskHistoryClose from "../../assets/risk_history_close.svg";
import AcceptedRisk_False from "../../assets/baseVersion/AcceptedRisk_False.svg";
import { SkeletonLoader } from "../../modules/dashboard/shared";
import fortinet_img from "../../assets/fortinet.svg"
import fortinet_scan_dark from "../../assets/fortinet_scan_dark.svg"
import fortinet_white from "../../assets/fortinet-white.svg"
import sophosLogo from "../../assets/sophos.svg";
import sophos_dark from "../../assets/sophos-white.svg";
import redhat_light from "../../assets/redhat_light.svg";
import redhat_dark from "../../assets/redhat_dark.svg";
import forinet from "../../assets/fortinet-white.svg"
import AWS_img from "../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../assets/baseVersion/AWS_DARK.svg";
import azure_img from "../../assets/baseVersion/azure.svg";
import azure_white from "../../assets/baseVersion/azure_white.svg";
import gcp_img from "../../assets/baseVersion/gcp.svg";
import gcp_dark from "../../assets/baseVersion/dark_agent_gcp.svg";

import { Microsoft } from "@mui/icons-material";


interface RiskHistoryDrawerProps {
  selectedRow?: any;
  // Header details
  title?: string;
  severity?: string;
  benchmarks?: string[];
  assetCount?: number;
  acceptedCount?: number;
  removedCount?: number;
  selectedRisk?: any;
}

// Custom Vendor Filter (checkbox list with search, Clear/Apply)
const VendorFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = React.useState<string[]>([]);
  const [isAll, setIsAll] = React.useState<boolean>(false);
  const [searchText, setSearchText] = React.useState<string>("");
  const options = useMemo(
    () => (Array.isArray(params.vendorOptions) ? params.vendorOptions : []),
    [params.vendorOptions]
  );

  const filtered = useMemo(() => {
    if (!searchText.trim()) return options;
    return options.filter((o) => o.toLowerCase().includes(searchText.toLowerCase()));
  }, [options, searchText]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = String(nodeParams.data?.vendor || "").toUpperCase().trim();
      return selected.map((s) => String(s).toUpperCase().trim()).includes(val);
    },
    getModel: () => (selected.length > 0 && !isAll ? { selectedTypes: selected } : null),
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) => (prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]));
    }
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === "function") (params as any).filterModifiedCallback();
  };

  const apply = () => {
    try {
      if (typeof (params as any).onApplyVendorFilter === "function") {
        (params as any).onApplyVendorFilter(selected, isAll);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplyVendorFilter === "function") {
        (params as any).onApplyVendorFilter([], true);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: 12,
        minWidth: 100,
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: 6,
        boxShadow: isDarkTheme ? "0 4px 6px rgba(0,0,0,0.3)" : "0 4px 6px rgba(0,0,0,0.1)",
        fontSize: 13,
      }}
    >
      <div style={{ marginBottom: 12, fontWeight: 600, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>Filter Vendor</div>
      <div style={{ marginBottom: 12 }}>
        <input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search..."
          style={{
            width: "100%",
            padding: "8px 10px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: 4,
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: 13,
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div className="scroll" style={{ maxHeight: 220, overflowY: "auto", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: isAll ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4 }}>
          <Checkbox size="small" checked={isAll} onChange={() => toggle("All")} />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filtered.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div key={opt} style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: checked ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4, marginTop: 2 }}>
              <Checkbox size="small" checked={checked} onChange={() => toggle(opt)} />
              <span style={{ marginLeft: 8 }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button onClick={clear} style={{ padding: "6px 12px", backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0", color: isDarkTheme ? "#f7fafc" : "#2d3748", border: "none", borderRadius: 4, cursor: "pointer" }}>Clear</button>
        <button onClick={apply} style={{ padding: "6px 12px", backgroundColor: "#0969da", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>Apply</button>
      </div>
    </div>
  );
});

// Custom Model Filter
const ModelFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = React.useState<string[]>([]);
  const [isAll, setIsAll] = React.useState<boolean>(false);
  const [searchText, setSearchText] = React.useState<string>("");
  const options = useMemo(
    () => (Array.isArray(params.modelOptions) ? params.modelOptions : []),
    [params.modelOptions]
  );

  const filtered = useMemo(() => {
    if (!searchText.trim()) return options;
    return options.filter((o) => o.toLowerCase().includes(searchText.toLowerCase()));
  }, [options, searchText]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = String(nodeParams.data?.deviceType || "").toUpperCase().trim();
      return selected.map((s) => String(s).toUpperCase().trim()).includes(val);
    },
    getModel: () => (selected.length > 0 && !isAll ? { selectedTypes: selected } : null),
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) => (prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]));
    }
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === "function") (params as any).filterModifiedCallback();
  };

  const apply = () => {
    try {
      if (typeof (params as any).onApplyModelFilter === "function") {
        (params as any).onApplyModelFilter(selected, isAll);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplyModelFilter === "function") {
        (params as any).onApplyModelFilter([], true);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: 12,
        minWidth: 100,
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: 6,
        boxShadow: isDarkTheme ? "0 4px 6px rgba(0,0,0,0.3)" : "0 4px 6px rgba(0,0,0,0.1)",
        fontSize: 13,
      }}
    >
      <div style={{ marginBottom: 12, fontWeight: 600, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>
        {params.filterTitle || "Filter Device Type"}
      </div>
      <div style={{ marginBottom: 12 }}>
        <input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search..."
          style={{
            width: "100%",
            padding: "8px 10px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: 4,
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: 13,
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div className="scroll" style={{ maxHeight: 220, overflowY: "auto", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: isAll ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4 }}>
          <Checkbox size="small" checked={isAll} onChange={() => toggle("All")} />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filtered.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div key={opt} style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: checked ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4, marginTop: 2 }}>
              <Checkbox size="small" checked={checked} onChange={() => toggle(opt)} />
              <span style={{ marginLeft: 8 }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button onClick={clear} style={{ padding: "6px 12px", backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0", color: isDarkTheme ? "#f7fafc" : "#2d3748", border: "none", borderRadius: 4, cursor: "pointer" }}>Clear</button>
        <button onClick={apply} style={{ padding: "6px 12px", backgroundColor: "#0969da", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>Apply</button>
      </div>
    </div>
  );
});

// Custom Host Name Filter
const HostNameFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = React.useState<string[]>([]);
  const [isAll, setIsAll] = React.useState<boolean>(false);
  const [searchText, setSearchText] = React.useState<string>("");
  const options = useMemo(
    () => (Array.isArray(params.hostOptions) ? params.hostOptions : []),
    [params.hostOptions]
  );

  const filtered = useMemo(() => {
    if (!searchText.trim()) return options;
    return options.filter((o) => o.toLowerCase().includes(searchText.toLowerCase()));
  }, [options, searchText]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = String(nodeParams.data?.hostName || "").toUpperCase().trim();
      return selected.map((s) => String(s).toUpperCase().trim()).includes(val);
    },
    getModel: () => (selected.length > 0 && !isAll ? { selectedTypes: selected } : null),
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) => (prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]));
    }
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === "function") (params as any).filterModifiedCallback();
  };

  const apply = () => {
    try {
      if (typeof (params as any).onApplyHostFilter === "function") {
        (params as any).onApplyHostFilter(selected, isAll);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplyHostFilter === "function") {
        (params as any).onApplyHostFilter([], true);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: 12,
        minWidth: 100,
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: 6,
        boxShadow: isDarkTheme ? "0 4px 6px rgba(0,0,0,0.3)" : "0 4px 6px rgba(0,0,0,0.1)",
        fontSize: 13,
      }}
    >
      <div style={{ marginBottom: 12, fontWeight: 600, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>Filter Host Name</div>
      <div style={{ marginBottom: 12 }}>
        <input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search..."
          style={{
            width: "100%",
            padding: "8px 10px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: 4,
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: 13,
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div className="scroll" style={{ maxHeight: 220, overflowY: "auto", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: isAll ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4 }}>
          <Checkbox size="small" checked={isAll} onChange={() => toggle("All")} />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filtered.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div key={opt} style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: checked ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4, marginTop: 2 }}>
              <Checkbox size="small" checked={checked} onChange={() => toggle(opt)} />
              <span style={{ marginLeft: 8 }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button onClick={clear} style={{ padding: "6px 12px", backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0", color: isDarkTheme ? "#f7fafc" : "#2d3748", border: "none", borderRadius: 4, cursor: "pointer" }}>Clear</button>
        <button onClick={apply} style={{ padding: "6px 12px", backgroundColor: "#0969da", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>Apply</button>
      </div>
    </div>
  );
});

// Custom Assets Filter
const AssetsFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = React.useState<string[]>([]);
  const [isAll, setIsAll] = React.useState<boolean>(false);
  const [searchText, setSearchText] = React.useState<string>("");
  const options = useMemo(
    () => (Array.isArray(params.assetOptions) ? params.assetOptions : []),
    [params.assetOptions]
  );

  const filtered = useMemo(() => {
    if (!searchText.trim()) return options;
    return options.filter((o) => o.toLowerCase().includes(searchText.toLowerCase()));
  }, [options, searchText]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = String(nodeParams.data?.assets || "").toUpperCase().trim();
      return selected.map((s) => String(s).toUpperCase().trim()).includes(val);
    },
    getModel: () => (selected.length > 0 && !isAll ? { selectedTypes: selected } : null),
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) => (prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]));
    }
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === "function") (params as any).filterModifiedCallback();
  };

  const apply = () => {
    try {
      if (typeof (params as any).onApplyAssetFilter === "function") {
        (params as any).onApplyAssetFilter(selected, isAll);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplyAssetFilter === "function") {
        (params as any).onApplyAssetFilter([], true);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: 12,
        minWidth: 100,
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: 6,
        boxShadow: isDarkTheme ? "0 4px 6px rgba(0,0,0,0.3)" : "0 4px 6px rgba(0,0,0,0.1)",
        fontSize: 13,
      }}
    >
      <div style={{ marginBottom: 12, fontWeight: 600, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>Filter Assets</div>
      <div style={{ marginBottom: 12 }}>
        <input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search..."
          style={{
            width: "100%",
            padding: "8px 10px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: 4,
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: 13,
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div className="scroll" style={{ maxHeight: 220, overflowY: "auto", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: isAll ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4 }}>
          <Checkbox size="small" checked={isAll} onChange={() => toggle("All")} />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filtered.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div key={opt} style={{ display: "flex", alignItems: "center", padding: "1px 8px", backgroundColor: checked ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: 4, marginTop: 2 }}>
              <Checkbox size="small" checked={checked} onChange={() => toggle(opt)} />
              <span style={{ marginLeft: 8 }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button onClick={clear} style={{ padding: "6px 12px", backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0", color: isDarkTheme ? "#f7fafc" : "#2d3748", border: "none", borderRadius: 4, cursor: "pointer" }}>Clear</button>
        <button onClick={apply} style={{ padding: "6px 12px", backgroundColor: "#0969da", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>Apply</button>
      </div>
    </div>
  );
});

const RiskHistoryDrawer = ({
  selectedRow,
  title = "Ensure 'Idle timeout' is less than or equal to Ensure 'Idle timeout'",
  severity = "Critical",
  benchmarks: benchmarksProp,
  assetCount = 20,
  acceptedCount = 10,
  removedCount = 25,
  selectedRisk,
}: RiskHistoryDrawerProps) => {
  console.log("selectedRow", selectedRow);
  const { isFrameworkOn } = useFrameworks();
  // Without benchmark info, show the default logos only for frameworks switched on
  const benchmarks = benchmarksProp ?? ["SPARK", "CIS", "NIST"].filter(isFrameworkOn);

  const [rowData, setRowData] = useState<any[]>([]);
  const [gridData, setGridData] = useState<any[]>([]);
  // const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState<string>("");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [isLoading, setIsLoading] = useState(false);

  const isCloudHistory = useMemo(() => {
    const module = String(selectedRisk?.module || selectedRow?.module || "").toLowerCase();
    if (module === "cloud") return true;
    if (module === "on_premise" || module === "onprem") return false;
    const cloudVendors = new Set([
      "amazonwebservices",
      "aws",
      "microsoftazure",
      "azure",
      "googlecloud",
      "googlecloudplatform",
      "gcp",
    ]);
    return rowData.some((r) =>
      cloudVendors.has(String(r?.vendor || "").toLowerCase().replace(/\s+/g, "").trim())
    );
  }, [selectedRisk?.module, selectedRow?.module, rowData]);

  useEffect(() => {
    const fetchRiskAcceptanceDetails = async () => {
      if (!selectedRow?.id) {
        setRowData([]);
        setGridData([]);
        setIsLoading(false);
        return;
      }
      setIsLoading(true);

      try {
        const response = await axiosInstance.post(
          END_POINTS.RISK_ACCEPTANCE_DETAILS_ACCEPT_RISK,
          {
            whitelist_history_id: selectedRow.id,
            approval_status: selectedRow.approval_status,
            expiry_date: selectedRow.expiry_date,
          }
        );

        if (response.data?.data?.whitelist_info) {
          const info = response.data.data.whitelist_info;
          const devices = Array.isArray(info.device_list) ? info.device_list : [];

          setReason(info.reason);
          const mappedDevices = devices.map((device: any) => ({
            acceptedRisk: device.whitelist,
            vendor: device.vendor,
            deviceType: device.device_type || device.resources_type || "-",
            hostName: device.host_name,
            assets: device.passed ? "success" : "error",
            approval_status: device.approval_status || info.approval_status || "",
            expiry_date: device.expiry_date ?? null,
          }));

          setRowData(mappedDevices);
          setGridData(mappedDevices);
        } else {
          setRowData([]);
          setGridData([]);
        }
      } catch (error) {
        console.error("Failed to fetch risk acceptance details:", error);
        setRowData([]);
        setGridData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRiskAcceptanceDetails();
  }, [selectedRow]);

  const formatDate = (input: string | number | Date): string => {
    const date = new Date(input);
    const pad = (n: number) => String(n).padStart(2, "0");

    const day = pad(date.getDate());
    const month = date.toLocaleString("en-US", { month: "long" }); // e.g., August
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };


  // Column definitions for the AgGridTable
  const columnDefs: ColDef[] = [
    {
      field: "acceptedRisk",
      headerName: "Accepted Risk",
      width: 150,
      minWidth: 130,
      filter: false,
      cellRenderer: (params: any) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {params.value ? (
            <img src={Exclamation} alt="warning" style={{ height: "20px" }} />
          ) : (
            <img
              src={AcceptedRisk_False}
              alt="warning"
              style={{ height: "20px" }}
            />
          )}
        </Box>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "vendor",
      headerName: "Vendor",
      minWidth: 120,
      width: 120,
      filter: VendorFilter,
      filterParams: {
        vendorOptions: useMemo(() => {
          const s = new Set<string>();
          rowData.forEach((r) => r?.vendor && s.add(String(r.vendor)));
          return Array.from(s);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplyVendorFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const targets = selected.map((s) => String(s).toUpperCase().trim());
          const filtered = rowData.filter((r) => targets.includes(String(r.vendor).toUpperCase().trim()));
          setGridData(filtered);
        },
      },
      cellRenderer: (params: any) => {
        const vendorLogos: any = {
          cisco: isDarkMode ? CiscoLogo_dark : ciscoLogo,
          paloalto: isDarkMode ? palaoto_dark : paloaltoLogo,
          arista: isDarkMode ? AristaLogo_dark : aristaLogo,
          juniper: isDarkMode ? JuniperLogo_dark : juniperLogo,
          fortinet: isDarkMode ? forinet : fortinet_img,
          sophos: isDarkMode ? sophos_dark : sophosLogo,
          ubuntu: isDarkMode ? ubuntu_dark : ubuntu_White,
          microsoft: isDarkMode ? Windows_dark : Windows_light,
          debian: isDarkMode ? debian_dark : debian,
          redhat: isDarkMode ? redhat_dark : redhat_light,
          huawei: isDarkMode ? huawei_dark : huawei_light,
          mikrotik: isDarkMode ? mikrotik_dark : mikrotik,
          edgecore: edgecore_logo,
          "tp-link": isDarkMode ? tplink_dark : tplink_light,
          tplink: isDarkMode ? tplink_dark : tplink_light,
          apple: isDarkMode ? apple_dark : apple_img,
          macos: isDarkMode ? apple_dark : apple_img,
          dell: dell_logo,
          amazonwebservices: isDarkMode ? AWS_DARK : AWS_img,
          aws: isDarkMode ? AWS_DARK : AWS_img,
          microsoftazure: isDarkMode ? azure_white : azure_img,
          azure: isDarkMode ? azure_white : azure_img,
          googlecloudplatform: isDarkMode ? gcp_dark : gcp_img,
          googlecloud: isDarkMode ? gcp_dark : gcp_img,
          gcp: isDarkMode ? gcp_dark : gcp_img,
          syrotech: isDarkMode ? syrotech_dark : syrotech_light,
        };

        const normalizedVendor = params.value?.toLowerCase().replace(/\s/g, "");
        const logoSrc = vendorLogos[normalizedVendor];

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "100%",
              paddingLeft: "5px",
            }}
          >
            {logoSrc ? (
              <img
                src={logoSrc}
                alt={params.value}
                style={{
                  maxWidth: "80px",
                  height: normalizedVendor === "huawei" ? "30px" : "24px",
                  objectFit: "contain",
                }}
              />
            ) : (
              <span>{params.value}</span>
            )}
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "deviceType",
      headerName: isCloudHistory ? "Resource Type" : "Device Type",
      width: 140,
      minWidth: 120,
      valueGetter: (params: any) => params.data?.deviceType || "-",
      filter: ModelFilter,
      filterParams: {
        filterTitle: isCloudHistory ? "Filter Resource Type" : "Filter Device Type",
        modelOptions: useMemo(() => {
          const s = new Set<string>();
          rowData.forEach((r) => {
            if (r?.deviceType && r.deviceType !== "-") s.add(String(r.deviceType));
          });
          return Array.from(s);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplyModelFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const targets = selected.map((s) => String(s).toUpperCase().trim());
          const filtered = rowData.filter((r) => targets.includes(String(r.deviceType).toUpperCase().trim()));
          setGridData(filtered);
        },
      },
      cellRenderer: (params: any) => (
        <Typography sx={{ fontSize: "16px" }}>
          {params.value}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "hostName",
      headerName: "Host Name",
      minWidth: 150,
      flex: 1,
      filter: HostNameFilter,
      filterParams: {
        hostOptions: useMemo(() => {
          const s = new Set<string>();
          rowData.forEach((r) => r?.hostName && s.add(String(r.hostName)));
          return Array.from(s);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplyHostFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const targets = selected.map((s) => String(s).toUpperCase().trim());
          const filtered = rowData.filter((r) => targets.includes(String(r.hostName).toUpperCase().trim()));
          setGridData(filtered);
        },
      },
      cellRenderer: (params: any) => (
        <Typography sx={{ fontSize: "16px" }}>
          {params.value}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "assets",
      headerName: "Assets",
      width: 120,
      minWidth: 100,
      filter: AssetsFilter,
      filterParams: {
        assetOptions: useMemo(() => {
          const s = new Set<string>();
          rowData.forEach((r) => {
            if (r?.assets !== null && r?.assets !== undefined) {
              // Map the values to user-friendly labels
              if (r.assets === "success" || r.assets === true) {
                s.add("Pass");
              } else if (r.assets === "error" || r.assets === false) {
                s.add("Fail");
              } else {
                s.add("N/A");
              }
            }
          });
          return Array.from(s);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplyAssetFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const filtered = rowData.filter((r) => {
            if (r?.assets === null || r?.assets === undefined) {
              return selected.includes("N/A");
            }
            if (r.assets === "success" || r.assets === true) {
              return selected.includes("Pass");
            }
            if (r.assets === "error" || r.assets === false) {
              return selected.includes("Fail");
            }
            return false;
          });
          setGridData(filtered);
        },
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        if (params.value === null || params.value === undefined) {
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img src={riskHistoryNA} alt="NA" style={{ height: "20px" }} />
            </Box>
          );
        }

        if (params.value === "success" || params.value === true) {
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src={riskHistoryTick}
                alt="Success"
                style={{ height: "20px" }}
              />
            </Box>
          );
        }

        if (params.value === "error" || params.value === false) {
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src={riskHistoryClose}
                alt="Error"
                style={{ height: "20px" }}
              />
            </Box>
          );
        }
        return null;
      },

    },
    {
      field: "approval_status",
      headerName: "Approval Status",
      width: 150,
      minWidth: 140,
      filter: false,
      valueGetter: (params: any) => params.data?.approval_status || "",
      cellRenderer: (params: any) => {
        const rawStatus = params.value;
        if (!rawStatus) {
          return (
            <Typography sx={{ fontSize: "14px" }}>-</Typography>
          );
        }

        const statusUpper = String(rawStatus).trim().toUpperCase();
        const isApproved = statusUpper.includes("APPROV") || statusUpper.includes("ACCEPT");
        const isRejected = statusUpper.includes("REJECT");
        const isPending = statusUpper.includes("PEND");
        const isExpired = statusUpper.includes("EXPIR") || statusUpper.includes("EXPIER");
        const displayLabel = isApproved
          ? "APPROVED"
          : isRejected
            ? "REJECTED"
            : isPending
              ? "PENDING"
              : isExpired
                ? "EXPIRED"
                : statusUpper;

        return (
          <Chip
            label={displayLabel}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: "11px",
              height: "22px",
              bgcolor: isApproved
                ? isDarkMode ? "rgba(46, 125, 50, 0.2)" : "rgba(46, 125, 50, 0.12)"
                : isPending
                  ? isDarkMode ? "rgba(255, 152, 0, 0.2)" : "#FFF4E5"
                  : isExpired || isRejected
                    ? isDarkMode ? "rgba(211, 47, 47, 0.2)" : "rgba(211, 47, 47, 0.12)"
                    : isDarkMode ? "rgba(255, 255, 255, 0.08)" : "#F2F4F7",
              color: isApproved
                ? isDarkMode ? "#81C784" : "#2e7d32"
                : isPending
                  ? isDarkMode ? "#FFB74D" : "#FF9800"
                  : isExpired || isRejected
                    ? isDarkMode ? "#FF8A80" : "#d32f2f"
                    : isDarkMode ? "#E2E8F0" : "#344054",
            }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "expiry_date",
      headerName: "Expiry Date",
      width: 160,
      minWidth: 140,
      filter: false,
      valueGetter: (params: any) => {
        const value = params.data?.expiry_date;
        if (value === null || value === undefined || String(value).trim() === "") return "-";
        const raw = String(value).trim();
        if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
          return raw.split(/[T ]/)[0];
        }
        return raw;
      },
      cellRenderer: (params: any) => (
        <Typography sx={{ fontSize: "14px" }}>
          {params.value || "-"}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  console.log("rowData", rowData);

  return (
    <>
      <Box
        sx={{ display: "flex", flexDirection: "column", p: 2, pr: 0, pb: 0 }}
      >
        <Box
          sx={{
            display: "flex",
            mb: 0,
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          {/* User info section - fixed width */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              minWidth: "200px",
              flexShrink: 0,
            }}
          >
            <Avatar
              sx={{ width: 40, height: 40 }}
              alt={
                selectedRisk
                  ? `${selectedRisk.first_name || ""} ${selectedRisk.last_name || ""
                  }`
                  : "User"
              }
            >
              {selectedRisk
                ? `${selectedRisk.first_name?.charAt(0) || ""}${selectedRisk.last_name?.charAt(0) || ""
                }`
                : "U"}
            </Avatar>
            <Box>
              <Typography
                variant="subtitle1"
                fontWeight="600"
                sx={{ fontSize: "14px" }}
              >
                {selectedRisk
                  ? `${selectedRisk.first_name || ""} ${selectedRisk.last_name || ""
                  }`
                  : "User"}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "12px" }}
              >
                {selectedRisk?.time ? formatDate(selectedRisk.time) : "Date"}
              </Typography>

            </Box>
          </Box>
          <Divider
            orientation="vertical"
            sx={{
              height: "40px",
              borderColor: "grey.400",
              mt: 1,
              display: { xs: "none", sm: "block" },
            }}
          />
          <Box
            sx={{
              flex: 1,
              overflow: "hidden",
              maxWidth: { xs: "100%", sm: "calc(100% - 240px)" },
            }}
          >
            <Typography
              variant="caption"
              color="primary"
              sx={{ fontSize: "12px", ml: { xs: 0, sm: 2 } }}
            >
              Reason
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                fontSize: "12px",
                ml: { xs: 0, sm: 2 },
                display: "block",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {reason}
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ width: "100", margin: 0, marginTop: 1 }} />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", p: 0, pt: 0 }}>
        <Box sx={{ mb: 1, p: 2 }}>
          <Box sx={{ mb: 1 }}>
            <Typography
              variant="subtitle1"
              fontWeight="500"
              sx={{ fontSize: "14px", mb: 1 }}
            >
              {title}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {(() => {
              const sevBg = severity === "Critical" ? (isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424") : severity === "High" ? (isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24") : severity === "Medium" ? (isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024") : (isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024");
              const sevColor = severity === "Critical" ? (isDarkMode ? "#FF3D3D" : "#670004") : severity === "High" ? (isDarkMode ? "#FF6B6B" : "#A7000F") : severity === "Medium" ? (isDarkMode ? "#FFA726" : "#E85800") : (isDarkMode ? "#FFE082" : "#F2BF00");
              return (
                <Chip
                  label={severity}
                  size="small"
                  sx={{
                    bgcolor: sevBg,
                    color: sevColor,
                    height: "20px",
                    borderRadius: "4px",
                    position: "relative",
                    fontWeight: 600,
                    p: 1.5,
                    pl: 2,
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: 8,
                      height: 8,
                      bgcolor: sevColor,
                      borderRadius: "50%",
                    },
                    "& .MuiChip-label": { px: 1 },
                  }}
                />
              );
            })()}
            <Divider orientation="vertical" flexItem />
            {benchmarks.includes("SPARK") && (
              <img
                src={isDarkMode ? spark_dark : sparkLogo}
                alt="spark"
                height="24"
              />
            )}
            {benchmarks.includes("CIS") && (
              <img
                src={isDarkMode ? cis_dark : csiLogo}
                alt="cis"
                height="24"
              />
            )}
            {benchmarks.includes("NIST") && (
              <img
                src={isDarkMode ? nist_dark : nistLogo}
                alt="nist"
                height="14"
                style={{ marginTop: 1 }}
              />
            )}
            <Divider orientation="vertical" flexItem />
            <Box sx={{ display: "flex", gap: 1 }}>
              <Chip
                label={`${assetCount} Assets`}
                size="small"
                sx={{
                  background: "linear-gradient(to right, #A3B4D3, #667A98)",
                  color: "#FFFFFF",
                  height: "20px",
                  borderRadius: "4px",
                  position: "relative",
                  fontWeight: 600,
                  p: 1.5,
                  pl: 0,
                  pr: 0,
                  "& .MuiChip-label": { px: 1 },
                }}
              />
              <Chip
                label={`${acceptedCount} Accepted`}
                size="small"
                sx={{
                  background: "linear-gradient(to right, #F63E57, #CD0C0D)",
                  color: "#fff",
                  height: "20px",
                  borderRadius: "4px",
                  position: "relative",
                  fontWeight: 600,
                  p: 1.5,
                  pl: 0,
                  pr: 0,
                  "& .MuiChip-label": { px: 1 },
                }}
              />
              <Chip
                label={`${removedCount} Removed`}
                size="small"
                sx={{
                  background: "linear-gradient(to right, #6BBD0E, #038C12)",
                  color: "#fff",
                  height: "20px",
                  borderRadius: "4px",
                  position: "relative",
                  fontWeight: 600,
                  p: 1.5,
                  pl: 0,
                  pr: 0,
                  "& .MuiChip-label": { px: 1 },
                }}
              />
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "98%" }} />

        {/* Table */}
        <Box sx={{ flex: 1 }}>
          {isLoading ? (
            <Box>
              <SkeletonLoader
                count={Math.floor(window.innerHeight / 45)}
                styles={{ height: 20 }}
              />
            </Box>
          ) : (
            <AgGridTable
              columnDefs={columnDefs}
              data={gridData || rowData}
              showSearch
              searchPlaceholder="Search Resource"
              height="calc(100vh - 220px)"
              loading={isLoading}
              gridOptions={{
                getRowStyle: (params) => {
                  return {
                    borderBottom: `1px solid ${isDarkMode ? "#2F3138" : "#f0f0f0"}`,
                  };
                },
                headerHeight: 40,
                rowHeight: 48,
              }}
              styles={{
                "& .ag-header": {
                  backgroundColor: isDarkMode ? "#393E4B" : "#f0f0f5",
                  color: isDarkMode ? "#F8F8FF" : "#5c5c5c",
                  fontWeight: 600,
                  fontSize: "13px",
                  borderBottom: `1px solid ${isDarkMode ? "#2F3138" : "#e0e0e0"}`,
                },
                "& .ag-header-cell": {
                  padding: "0 8px",
                },
                "& .ag-cell": {
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                },
              }}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default RiskHistoryDrawer;
